import { render, staticRenderFns } from "./buscaAudio.vue?vue&type=template&id=1d2c5c1d&scoped=true&"
import script from "./buscaAudio.vue?vue&type=script&lang=js&"
export * from "./buscaAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c5c1d",
  null
  
)

export default component.exports